@if (message.meta == null) {
  <div
    class="message-bubble"
    class="{{ bubbleClass }}"
    (mouseenter)="hovering = true"
    (mouseleave)="hovering = false"
  >
    @if (message.replyingTo != null) {
      <div class="reply-bubble {{ replyBubbleClass }}">
        <!-- Normal message -->
        @if (replyBubbleClass == "me") {
          <div class="reply-text">
            <i class="feather corner-up-right"></i>
            {{ message.replyingTo.sent_by.full_name }} replied to you
          </div>
        }
        @if (replyBubbleClass == "others") {
          <div class="reply-text">
            <i class="feather corner-up-right"></i>
            {{
              message.sent_by != null && message.sent_by.id !== user.id
                ? message.sent_by.full_name
                : "You"
            }}
            replied to {{ message.replyingTo.sent_by.full_name }}
          </div>
        }
        @if (
          (message.replyingTo.tracked_item == null &&
            message.replyingTo.system_message == null) ||
          is_comment
        ) {
          <div
            class="message-bubble-wrapper"
            tooltip="{{
              message.replyingTo.date
                | amFromUtc
                | amLocal
                | amDateFormat: 'MMM, Do YYYY, h:mm A'
            }}"
            container="body"
          >
            @if (!isDeleted()) {
              <div class="message-bubble-title">
                @if (
                  message.replyingTo.sent_by != null &&
                  message.replyingTo.sent_by.id !== user.id
                ) {
                  <div class="title">
                    {{ message.replyingTo.sent_by.full_name }}
                  </div>
                }
                @if (
                  message.replyingTo.sent_by != null &&
                  message.replyingTo.sent_by != null &&
                  message.replyingTo.sent_by.id === user.id
                ) {
                  <div class="title">You</div>
                }
                @if (message.replyingTo.date != null) {
                  <div class="date">
                    {{
                      message.replyingTo.date | amFromUtc | amLocal | amCalendar
                    }}
                  </div>
                }
              </div>
            }
            @if (!isDeleted() && message.replyingTo.file != null) {
              <p class="text">
                <a
                  class="message-download-link"
                  target="_blank"
                  rel="noreferrer noopener"
                  [href]="message.replyingTo.file?.url"
                  [download]="message.replyingTo.file?.filename"
                  filePreview
                  [disabledButtons]="['delete', 'rename', 'move']"
                  [file]="message.replyingTo.file"
                >
                  @if (
                    fileImageExtensions.includes(message.replyingTo.file?.ext)
                  ) {
                    <secured-image [src]="message.replyingTo.file?.etag">
                    </secured-image>
                  } @else {
                    <div>
                      <i class="feather download"></i>
                      {{ message.replyingTo.file?.filename }}
                    </div>
                  }
                </a>
              </p>
            }
            <!-- Edit mode false -->
            <div>
              @if (!isDeleted()) {
                <div
                  class="text"
                  [innerHTML]="
                    _sanitizer.bypassSecurityTrustHtml(
                      message.replyingTo.message | linkify
                    )
                  "
                ></div>
              } @else {
                <div
                  class="text"
                  style="font-style: italic; opacity: 0.5; font-size: 0.9em"
                >
                  This message has been deleted
                </div>
              }
              @if (!isDeleted() && message.replyingTo.edited) {
                <p
                  class="text"
                  style="
                    font-style: italic;
                    opacity: 0.5;
                    font-size: 0.75em;
                    text-align: right;
                  "
                >
                  (edited)
                </p>
              }
            </div>
          </div>
        }
      </div>
    }
    <!-- endreply -->
    @if (message.reminder) {
      <div
        class="avatar avatar-32"
        [ngClass]="{
          'avatar-bot': message.reminder == true,
        }"
      ></div>
    }
    @if (message.reminder) {
      <div class="message-bubble-wrapper">
        @if (message.date != null) {
          <div
            class="date"
            style="
              font-size: 12px !important;
              max-width: 100% !important;
              overflow: hidden !important;
            "
          >
            {{ message.date | amFromUtc | amLocal | amCalendar }}
          </div>
        } @else {
          <div class="date" style="padding-right: 3px">🕒</div>
        }
        <div>
          <div class="text">
            <span class="user">{{ message.reminder_creator.full_name }}</span>
            has nudged you to reply to the outstanding client tasks
          </div>
        </div>
      </div>
    }
    <!-- Normal message -->
    @if (
      (message.tracked_item == null && message.system_message == null) ||
      is_comment
    ) {
      <div class="message-bubble-wrapper">
        @if (!isDeleted()) {
          <div class="message-bubble-title">
            <div class="message-bubble-title-date-wrapper">
              @if (message.sent_by != null && message.sent_by.id !== user.id) {
                <div class="title">
                  {{ message.sent_by.full_name }}
                </div>
              }
              @if (message.sent_by != null && message.sent_by.id === user.id) {
                <div class="title">You</div>
              }
              @if (message.date != null) {
                <div
                  class="date"
                  tooltip="{{
                    message.date | amDateFormat: 'MMM, Do YYYY, h:mm A'
                  }}"
                >
                  {{ message.date | amFromUtc | amLocal | amCalendar }}
                </div>
              } @else {
                <div class="date" style="padding-right: 3px">🕒</div>
              }
            </div>
            @if (!is_comment) {
              <ds-pin
                [hovering]="hovering"
                [type]="pinModel"
                [identifier]="message.uuid"
                [model]="message"
                [company]="{
                  id: dashboardStore.currentCompany.id,
                  uuid: dashboardStore.currentCompany.uuid,
                }"
                [additionalAttributes]="{ conversationUuid: conversation_uuid }"
              />
            }
          </div>
        }
        @if (!isDeleted() && message.file != null) {
          <p class="text">
            <a
              class="message-download-link"
              target="_blank"
              rel="noreferrer noopener"
              [href]="message.file?.url"
              [download]="message.file?.filename"
              filePreview
              [disabledButtons]="['delete', 'rename', 'move']"
              [file]="message.file"
            >
              @if (fileImageExtensions.includes(message.file?.ext)) {
                <secured-image [src]="message.file?.etag"> </secured-image>
              } @else {
                <div>
                  <i class="feather download"></i> {{ message.file?.filename }}
                </div>
              }
            </a>
          </p>
        }
        <!-- Edit mode false -->
        @if (!message.edit_mode) {
          <div>
            @if (!isDeleted()) {
              <div
                class="text"
                [innerHTML]="
                  !isSearchMode
                    ? !is_comment
                      ? _sanitizer.bypassSecurityTrustHtml(
                          message.message | linkify
                        )
                      : _sanitizer.bypassSecurityTrustHtml(message.message)
                    : _sanitizer.bypassSecurityTrustHtml(message.message)
                "
              ></div>
            } @else {
              <div
                class="text"
                style="font-style: italic; opacity: 0.5; font-size: 0.9em"
              >
                This message has been deleted
              </div>
            }
            @if (!isDeleted() && (message.edited || message.is_edited)) {
              <p
                class="text"
                style="
                  font-style: italic;
                  opacity: 0.5;
                  font-size: 0.75em;
                  text-align: right;
                "
              >
                (edited)
              </p>
            }
          </div>

          @if (message.reactions?.length) {
            <div class="reactions-container">
              @for (reaction of message.reactions; track $index) {
                <div
                  tooltip="{{ reaction.owners | showOwnerNames }}"
                  class="reaction"
                  (click)="handleReactionClick(reaction)"
                  placement="bottom"
                >
                  <ngx-emoji
                    set="apple"
                    [emoji]="reaction.emoji_obj.id"
                    size="20"
                  ></ngx-emoji>
                  <span
                    class="reaction-count"
                    [style]="
                      isSender() ? { color: 'white' } : { color: 'black' }
                    "
                    >{{ reaction.owners.length }}</span
                  >
                </div>
              }
            </div>
          }
        }

        <!-- Edit mode true -->
        @if (message.edit_mode == true) {
          <textarea
            style="
              border: none !important;
              outline: none !important;
              box-shadow: none !important;
              padding: 0 !important;
            "
            class="form-control chat-input in-message-edit"
            rows="1"
            autosize
            #inputMessage
            [(ngModel)]="message.message"
            autofocus
            placeholder="Type a message..."
          ></textarea>
        }
        @if (message.edit_mode == true) {
          <button
            class="btn btn-light"
            style="margin-right: 5px"
            (click)="editMessageConfirm(message)"
          >
            <i class="feather check"></i> Save
          </button>
        }
        @if (message.edit_mode == true) {
          <button (click)="cancelEdit(message)" class="btn btn-primary">
            Cancel
          </button>
        }
        <!-- options menu -->
        @if (!disabled) {
          <div class="message-actions">
            <!-- Emojis -->
            @if (!is_comment) {
              <span
                dropdown
                container="body"
                #dropdown="bs-dropdown"
                [autoClose]="true"
                [insideClick]="true"
              >
                <span id="dLabel" type="button" dropdownToggle>
                  <i
                    class="tio-wink"
                    style="font-size: 20px"
                    tooltip="React"
                  ></i>
                </span>
                <ul
                  aria-labelledby="dLabel"
                  id="dropdown-triggers-manual"
                  *dropdownMenu
                  class="dropdown-menu reaction-dropdown-menu"
                  role="menu"
                  aria-labelledby="button-triggers-manual"
                >
                  <li>
                    <emoji-mart
                      [style]="emojiConfig.style"
                      (emojiClick)="addReaction($event)"
                      [set]="emojiConfig.set"
                      [sheetSize]="emojiConfig.sheetSize"
                      [include]="emojiConfig.include"
                      [darkMode]="emojiConfig.darkMode"
                      [i18n]="emojiConfig.i18n"
                    ></emoji-mart>
                  </li>
                </ul>
              </span>
            }

            <!-- Reply action -->
            @if (!isSender() && canReply()) {
              <i
                (click)="addReply(message)"
                class="feather corner-up-right"
                tooltip="Reply"
              ></i>
            }

            <span
              dropdown
              container="body"
              #dropdown="bs-dropdown"
              [autoClose]="true"
            >
              <span id="dLabel" type="button" dropdownToggle>
                <i class="feather more-horizontal" tooltip="More"></i>
              </span>
              <ul
                aria-labelledby="dLabel"
                id="dropdown-triggers-manual"
                *dropdownMenu
                class="dropdown-menu tag-add-dropdown-menu"
                role="menu"
                aria-labelledby="button-triggers-manual"
              >
                @if (isSender() && canEdit()) {
                  <li>
                    <a (click)="editMessage(message)"
                      ><i class="feather edit"></i> Edit</a
                    >
                  </li>
                }
                @if (isSender() && canDelete()) {
                  <li>
                    <a (click)="toggleMessageVisibility(message)"
                      ><i class="feather trash-2"></i> Delete</a
                    >
                  </li>
                }
                @if (isSender() && canRestore()) {
                  <li>
                    <a (click)="toggleMessageVisibility(message)"
                      ><i class="feather rotate-ccw"></i> Restore</a
                    >
                  </li>
                }
                @if (!isSender() && canCreateJob()) {
                  <li>
                    <a (click)="createJobFromMessage()"
                      ><i class="feather check-square"></i> Create Job</a
                    >
                  </li>
                }
              </ul>
            </span>
          </div>
        }
      </div>
    }
  </div>
}

<ng-template #removePinModal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="bsModalRef.hide()"
      aria-label="Close"
    >
      <i class="feather x"></i>
    </button>
    <h4 class="modal-title">Remove Pin</h4>
  </div>
  <div class="modal-body text-center">
    <i class="feather trash-2 x3" style="color: #bd1105"></i>
    <p>Are you sure you want to remove the pin from this message?</p>
    <div class="btn btn-danger btn-block" (click)="removePin(message)">
      Remove Pin
    </div>
  </div>
  <div class="modal-footer">
    <div
      class="btn btn-default btn-block"
      aria-label="Cancel"
      (click)="bsModalRef.hide()"
    >
      Cancel
    </div>
  </div>
</ng-template>
